/* eslint-disable */
/* tslint:disable */
import * as React from 'react';
const left = ({ size, ...props }) => (React.createElement("svg", { viewBox: "0 0 938 1000", fill: "currentColor", width: size || '1em', height: size || '1em', ...props },
    React.createElement("path", { fill: "currentColor", d: "M0 497l390-391q19-18 44-18t43 18 18 44-18 43L234 436h642q25 0 43 18t18 43-18 43-43 18H234l243 243q18 18 18 44t-18 43-43 18-44-18z" })));
left.displayName = 'left';
export default left;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=left.js.map